import { ForgotPasswordScreen } from '@avrahami/ui';
import { Link } from '@tanstack/react-router';
import { passwordResetApi } from '../api/session';
import { he } from '../i18n/he';
import { errorMessage } from '../lib/forms';

/** Public page: asks for a link that sets a new password (adr/0035). */
export function ForgotPasswordPage() {
  return (
    <ForgotPasswordScreen
      product={he.app.product}
      words={he.forgotPassword}
      request={passwordResetApi.request}
      errorText={errorMessage}
      loginLink={
        <Link to="/login" search={{}} className="text-center text-sm text-brand-700 underline">
          {he.forgotPassword.goToLogin}
        </Link>
      }
    />
  );
}
